import { Form, Input } from 'antd'
import React from 'react'

import { CommonBasicInfo } from '@/components/CommonBasicInfo'

import { BasicInfoProps } from '../types'
import { EntryComponentsWrapper } from 'packages/theme'

/**
 * 课程 - 基本信息
 *
 * @param param0 - 参数
 * @param param0.form - 表单实例
 * @param param0.basicInfoRef - 基本信息 ref
 * @param param0.commonBasicInfo - 基本信息
 * @param param0.setTitle - 设置标题
 * @param param0.activityTaskOptions - 任务选项
 * @returns  component
 */
export const BasicInfo: React.FC<
  BasicInfoProps & {
    isSubmit: boolean
  }
> = ({
  form,
  basicInfoRef,
  commonBasicInfo,
  setTitle,
  activityTaskOptions,
  isSubmit,
}) => {
  return (
    <EntryComponentsWrapper>
      <Form
        colon={false}
        form={form}
        wrapperCol={{ span: 22 }}
        labelCol={{ span: 2 }}
        initialValues={{
          isShow: true,
        }}
      >
        <Form.Item
          label="课程标题"
          name="name"
          rules={[{ required: true, message: '请输入课程标题' }]}
        >
          <Input
            placeholder="请输入课程标题"
            onChange={(e) => {
              setTitle?.(e.target.value)
            }}
            maxLength={200}
          />
        </Form.Item>
        <CommonBasicInfo
          form={form}
          ref={basicInfoRef}
          value={commonBasicInfo}
          activityTaskOptions={activityTaskOptions || []}
          openTypeDisabled={!!isSubmit}
        />
      </Form>
    </EntryComponentsWrapper>
  )
}
